/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AttributeMasterEditor extends Common.GridEditorBase<AttributeMasterRow> {
        protected getColumnsKey() { return "OMS.AttributeMaster"; }
        protected getDialogType() { return AttributeMasterDialog; }
        protected getLocalTextPrefix() { return AttributeMasterRow.localTextPrefix; }
        protected getInsertPermission() { return AttributeMasterRow.insertPermission; }
        protected getUpdatePermission() { return AttributeMasterRow.updatePermission; }
        protected getDeletePermission() { return AttributeMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        constructor(container: JQuery) {
            super(container);
        }
        /*
        validateEntity(row, id) {
            row.AtbId = Q.toId(row.AtbId);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.AtbId === row.AtbId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This product is already in order details!');
                return false;
            }

            row.ProductName = ProductRow.getLookup().itemById[row.ProductID].ProductName;
            row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }*/
    }
}